import axiosInstance from "@/api/axiosInstance";

/** The caller's own coach for their active company (see LearnerCoachResolver). */
export interface MyCoach {
  userId: number;
  name: string;
  email: string | null;
  bookingUrl: string | null;
}

export interface GetMyCoachResponse {
  coach: MyCoach | null;
}

export const getMyCoach = async (): Promise<GetMyCoachResponse> => {
  const response = await axiosInstance.get("/api/coaching/my-coach", {
    silent: true,
  });
  return response.data.data;
};
